<div class="dialog">
    <div class="row container">
        <div class="col-md-12" >
            <div class="content">
                <img src="../../../assets/images/logo_white.png" width="100px">
            </div>
        </div>

        <!-- <div class="col-md-4 parDiv">
            <p>call us: +27 (0)62 263 1710</p>
        </div> -->
    </div>
    <hr color="white" class="rounded" size="8" width="100%">
    <h4 class="text-center">Reset Password</h4>

    <div class="alert alert-danger" *ngIf="errorLogging" role="alert">
        {{errorMessage}}
      </div>
      <div class="alert alert-success" *ngIf="passwordResetSuccess" role="alert">
        <p>Your Password has been reset successfully !</p>
      </div>
    <form class="row" [formGroup]="resetForm">
        <div *ngIf="showForgotPwdField" class="form-group col-sm-12">
            <label for="Email">Email</label>
            <input type="text" formControlName="username" class="form-control" id="email" placeholder="Type your Email">
        </div>

        <div *ngIf="showForgotPwdSubmitField" class="form-group col-sm-12">
            <div class="form-group">
                <label for="New Password">Enter Email</label>
                <input type="text" formControlName="email" class="form-control" id="email" placeholder="Type New Password">
            </div>
    
            <div class="form-group">
                <label for="Code">Code</label>
                <input type="text" formControlName ="code" class="form-control" id="code" placeholder="Enter Code">
            </div>

            <div class="form-group">
                <label for="New Password">New password</label>
                <input type="text" formControlName ="new_Pwd" class="form-control" id="new_Pwd" placeholder="Enter New Password">
            </div>

            <div class="form-group">
                <label for="Confirm Password">Confirm New Password</label>
                <input type="text" formControlName ="conf_Pwd" class="form-control" id="conf_Pwd" placeholder="re Enter New Password">
            </div>
        </div>

        <div *ngIf="showForgotPwdField" class="form-group col-sm-12">
            <div class="row">
                <div class="col-sm-12">
                    <button class="btn btn-primary m-b-1"  (click)="onSubmitUsername()">Submit</button>
                </div>
    
                <!-- <div class="col-sm-6">
                    <button class="btn btn-primary m-b-1 dialog__close-btn">Cancel</button>
                </div> -->
            </div>
           
        </div>
       


        <div *ngIf="showForgotPwdSubmitField" class="form-group col-sm-12">
            <div class="row">
                <div class="col-sm-6">
                    <button class="btn btn-primary m-b-1"  (click)="onSubmitNewPassword()">Reset Password</button>
                </div>
    
                <div class="col-sm-6">
                    <button class="btn btn-primary m-b-1 dialog__close-btn">Cancel</button>
                </div>
            </div>
        </div>
        
    </form>
</div>